import { Icon } from "@silversea-ssc/ui-components-react"
import React from "react"
import clsx from "clsx"
import styles from "./Step.module.scss"
import { StepState } from "./Step"

type Props = {
    state: StepState
}

const StepSeparator: React.FC<Props> = ({ state }) => {
    return (
        <Icon
            wrapperClassName={styles.separator}
            className={clsx({ [styles.separatorCompleted]: state == "completed" })}
            name="chevron-right"
            padding={false}
            size="1x"
            ariaHidden={true}
        />
    )
}

export default StepSeparator
